import type React from 'react';

import { AddVerktoyConfirmation } from './add-verktoy-confirmation';
import DeleteVerktoyConfirmation from './delete-verktoy-confirmation';
import DeleteVerktoyConfirmationMineVerktoy from './delete-verktoy-confirmation-mine-verktoy';
import { useAppSelector } from '../../store';

export const ModalsContainer = (): React.JSX.Element => {
  const addedAktivitetName = useAppSelector(globalState => globalState.verktoy.addedAktivitetName);
  const aktivitetToRemove = useAppSelector(globalState => globalState.verktoy.aktivitetToRemove);

  const aktivitetToRemoveMineVerktoy = useAppSelector(globalState => globalState.verktoy.aktivitetToRemoveMineVerktoy);

  return (
    <>
      {aktivitetToRemove && <DeleteVerktoyConfirmation />}
      {aktivitetToRemoveMineVerktoy && <DeleteVerktoyConfirmationMineVerktoy />}
      {addedAktivitetName && <AddVerktoyConfirmation />}
    </>
  );
};

export default ModalsContainer;
